const STANDARD_WHITE_1 = {
  url: 'https://res.insta360.com/static/9ced1f5119403059d298908c99207d1c/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E7%99%BD@2x.jpg',
  urlL: 'https://res.insta360.com/static/4db5491166ae3c16e51ba5784ea6c3d3/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E7%99%BD@3x.jpg',
  url_m:
    'https://res.insta360.com/static/9ced1f5119403059d298908c99207d1c/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E7%99%BD@2x.jpg',
  url_s:
    'https://res.insta360.com/static/630a70cc1b8ac6f3d4271861fadded15/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E7%99%BD.jpg',
};
const STANDARD_BLACK_1 = {
  url: 'https://res.insta360.com/static/e8fd1a2e33002d57296a61667bae0428/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E9%BB%91@2x.jpg',
  urlL: 'https://res.insta360.com/static/b3d79ac5df0d36c085eb4d35b874a0a0/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E9%BB%91@3x.jpg',
  url_m:
    'https://res.insta360.com/static/e8fd1a2e33002d57296a61667bae0428/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E9%BB%91@2x.jpg',
  url_s:
    'https://res.insta360.com/static/d99fb0cb978a734da9aa125f69034a1d/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E9%BB%91.jpg',
};
const STANDARD_2 = {
  url: 'https://res.insta360.com/static/852976ecbd0676a2f1f3bc7b3c666a76/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9002@2x.jpg',
  urlL: 'https://res.insta360.com/static/2172e8ff15db74b07501c4158b0d5146/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9002@3x.jpg',
  url_m:
    'https://res.insta360.com/static/852976ecbd0676a2f1f3bc7b3c666a76/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9002@2x.jpg',
  url_s: 'https://res.insta360.com/static/66e253bf8c2c10173d702e8c340e83bc/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9002.jpg',
};
const STANDARD_3 = {
  url: 'https://res.insta360.com/static/468c834ec610b6e798abda8047280b68/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9003@2x.jpg',
  urlL: 'https://res.insta360.com/static/e8bff6f24d7a735537e2110ea2cd9593/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9003@3x.jpg',
  url_m:
    'https://res.insta360.com/static/468c834ec610b6e798abda8047280b68/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9003@2x.jpg',
  url_s: 'https://res.insta360.com/static/ad0353b8d0b93f9d8e8bf7a76df5d8c3/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9003.jpg',
};
const STANDARD_4 = {
  url: 'https://res.insta360.com/static/dd3b7a80f092b9bde40bc28ec615e693/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9004@2x.jpg',
  urlL: 'https://res.insta360.com/static/d8ab07de671fa8a305d98960a0817080/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9004@3x.jpg',
  url_m:
    'https://res.insta360.com/static/dd3b7a80f092b9bde40bc28ec615e693/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9004@2x.jpg',
  url_s: 'https://res.insta360.com/static/918120c20dcf9bc17f9b94f492513665/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9004.jpg',
};
const FAMILY_WHITE_1 = {
  url: 'https://res.insta360.com/static/19c3bc7dbcce18328fd258284a2b76ec/01@2x.jpg',
  urlL: 'https://res.insta360.com/static/bc6344bc08493721769ad83fb02955f5/01@3x.jpg',
  url_m: 'https://res.insta360.com/static/19c3bc7dbcce18328fd258284a2b76ec/01@2x.jpg',
  url_s: 'https://res.insta360.com/static/094d1114e7737e0c8d29d98d73d3b7cd/01.jpg',
};
const FAMILY_BLACK_1 = {
  url: 'https://res.insta360.com/static/2e00cb089b54b61faffdb66d16d1c552/02-%E9%BB%91@2x.jpg',
  urlL: 'https://res.insta360.com/static/e7ef35d359c5ebdd098c940428a92542/02-%E9%BB%91@3x.jpg',
  url_m: 'https://res.insta360.com/static/2e00cb089b54b61faffdb66d16d1c552/02-%E9%BB%91@2x.jpg',
  url_s: 'https://res.insta360.com/static/3a6656d2aca26a8c1d71ff7e5cc236fb/02-%E9%BB%91.jpg',
};
const FAMILY_2 = {
  url: 'https://res.insta360.com/static/95b3e2896c88ef65c3e3d950dc681168/03@2x.jpg',
  urlL: 'https://res.insta360.com/static/e9973c77130253a1fb2b57d7ac711586/03@3x.jpg',
  url_m: 'https://res.insta360.com/static/95b3e2896c88ef65c3e3d950dc681168/03@2x.jpg',
  url_s: 'https://res.insta360.com/static/35446e1e83c79b70185ac70b1f829299/03.jpg',
};
const FAMILY_3 = {
  url: 'https://res.insta360.com/static/c756d1aad07183bc4afefe4ddae6d3e4/04@2x.jpg',
  urlL: 'https://res.insta360.com/static/6cf9065e67f33ccd6be8f17cfe60886e/04@3x.jpg',
  url_m: 'https://res.insta360.com/static/c756d1aad07183bc4afefe4ddae6d3e4/04@2x.jpg',
  url_s: 'https://res.insta360.com/static/385ea8e6f2779001d8285e66f83252cf/04.jpg',
};
const FAMILY_4 = {
  url: 'https://res.insta360.com/static/10339f6e62fa73c8567cb900cc3907c6/05@2x.jpg',
  urlL: 'https://res.insta360.com/static/fe15f3b093b562c766608a217dae8a43/05@3x.jpg',
  url_m: 'https://res.insta360.com/static/10339f6e62fa73c8567cb900cc3907c6/05@2x.jpg',
  url_s: 'https://res.insta360.com/static/28a7221f11985af1941d9ce544d69e55/05.jpg',
};
const ULTIMATE_WHITE_1 = {
  url: 'https://res.insta360.com/static/da444b2cbdb4b554663c6396f8b3b579/01@2x.jpg',
  urlL: 'https://res.insta360.com/static/69b4beebfc26d582261fe2f3455cc728/01@3x.jpg',
  url_m: 'https://res.insta360.com/static/da444b2cbdb4b554663c6396f8b3b579/01@2x.jpg',
  url_s: 'https://res.insta360.com/static/e25ae45c8802a86edca3f5dacc2c8a16/01.jpg',
};
const ULTIMATE_BLACK_1 = {
  url: 'https://res.insta360.com/static/952591b3a3bf84bae45f230f09796019/02-%E9%BB%91@2x.jpg',
  urlL: 'https://res.insta360.com/static/cc8dc5920ba774b5374a23390d548e0e/02-%E9%BB%91@3x.jpg',
  url_m: 'https://res.insta360.com/static/952591b3a3bf84bae45f230f09796019/02-%E9%BB%91@2x.jpg',
  url_s: 'https://res.insta360.com/static/4ef53edaa84cb5c3b5bc6ac8ea954f31/02-%E9%BB%91.jpg',
};
const ULTIMATE_2 = {
  url: 'https://res.insta360.com/static/ab298e11f1e02f804aa3afa6530d9abb/03@2x.jpg',
  urlL: 'https://res.insta360.com/static/5b594121841e566235818dcc010a68b9/04@3x.jpg',
  url_m: 'https://res.insta360.com/static/ab298e11f1e02f804aa3afa6530d9abb/03@2x.jpg',
  url_s: 'https://res.insta360.com/static/5c2c6860a897fc45d2542cd57afc4d19/03.jpg',
};
const ULTIMATE_3 = {
  url: 'https://res.insta360.com/static/4006f8bc2b21fccbea1bb7d5ea36b3f5/04@2x.jpg',
  urlL: 'https://res.insta360.com/static/1ab7e25bd553b6f4bf768f4b77aeaff8/03@3x.jpg',
  url_m: 'https://res.insta360.com/static/4006f8bc2b21fccbea1bb7d5ea36b3f5/04@2x.jpg',
  url_s: 'https://res.insta360.com/static/39d84b136f48831c8537b1064857a3d9/04.jpg',
};
const ULTIMATE_4 = {
  url: 'https://res.insta360.com/static/2e4c8e412e5842fb6527e6e56ebf5a51/05@2x.jpg',
  urlL: 'https://res.insta360.com/static/4d4f8abf18768ac85a619145206e1298/05@3x.jpg',
  url_m: 'https://res.insta360.com/static/2e4c8e412e5842fb6527e6e56ebf5a51/05@2x.jpg',
  url_s: 'https://res.insta360.com/static/2bf700d78079e4e55eacbbaf31b13e48/05.jpg',
};

const ACTION_WHITE_1 = {
  url: 'https://res.insta360.com/static/333033c45c6db4e8f3241bcd084a5fdc/01@2x.jpg',
  urlL: 'https://res.insta360.com/static/e3f75321cc160d2dcae920d2eb58c3e9/01@3x.jpg',
  url_m: 'https://res.insta360.com/static/333033c45c6db4e8f3241bcd084a5fdc/01@2x.jpg',
  url_s: 'https://res.insta360.com/static/1534bfcdb65e5c77408213e490728f20/01.jpg',
};
const ACTION_BLACK_1 = {
  url: 'https://res.insta360.com/static/d66ac1edc23257c490f9caa22c0491ca/02-%E9%BB%91@2x.jpg',
  urlL: 'https://res.insta360.com/static/6cba52b03dca5a0a7d5312ab6326c460/02-%E9%BB%91@3x.jpg',
  url_m: 'https://res.insta360.com/static/d66ac1edc23257c490f9caa22c0491ca/02-%E9%BB%91@2x.jpg',
  url_s: 'https://res.insta360.com/static/78ce5de3b306467f369463d9f6527ef6/02-%E9%BB%91.jpg',
};
const ACTION_2 = {
  url: 'https://res.insta360.com/static/f57fafcfa92b47f1366b76ffe93576a9/03@2x.jpg',
  urlL: 'https://res.insta360.com/static/ac8b4c5d88eb70d2f5618b834866466b/03@3x.jpg',
  url_m: 'https://res.insta360.com/static/f57fafcfa92b47f1366b76ffe93576a9/03@2x.jpg',
  url_s: 'https://res.insta360.com/static/ad64dd819072f6f894a29e2adaa388f7/03.jpg',
};
const ACTION_3 = {
  url: 'https://res.insta360.com/static/606e2c33b125f9e7b231450e70ba066d/04@2x.jpg',
  urlL: 'https://res.insta360.com/static/fd85c5c38fed397306a7928afe380f14/04@3x.jpg',
  url_m: 'https://res.insta360.com/static/606e2c33b125f9e7b231450e70ba066d/04@2x.jpg',
  url_s: 'https://res.insta360.com/static/ce50f313e609dc1028e48f7458929f69/04.jpg',
};

const ACTION_4 = {
  url: 'https://res.insta360.com/static/5c8a70989a1c7c7d508c82bb1237604e/05@2x.jpg',
  urlL: 'https://res.insta360.com/static/3a23fc62807e1f21a0a7f2985edb5bc1/05@3x.jpg',
  url_m: 'https://res.insta360.com/static/5c8a70989a1c7c7d508c82bb1237604e/05@2x.jpg',
  url_s: 'https://res.insta360.com/static/ef7360b78f0a7cf172bba26916305790/05.jpg',
};
const CREATOR_WHITE_1 = {
  url: 'https://res.insta360.com/static/ff813d0114a5e4c90c712041ddf1e592/01@2x.jpg',
  urlL: 'https://res.insta360.com/static/8339d90b7a619718940274ed8051a555/01@3x.jpg',
  url_m: 'https://res.insta360.com/static/ff813d0114a5e4c90c712041ddf1e592/01@2x.jpg',
  url_s: 'https://res.insta360.com/static/c00ffae62ed879c64c07666c665b4f0e/01.jpg',
};
const CREATOR_BLACK_1 = {
  url: 'https://res.insta360.com/static/8c09b1e2a9ded560fad543a75437eb70/02-%E9%BB%91@2x.jpg',
  urlL: 'https://res.insta360.com/static/8fcefe9d05ed9a65b53301394cc78870/02-%E9%BB%91@3x.jpg',
  url_m: 'https://res.insta360.com/static/8c09b1e2a9ded560fad543a75437eb70/02-%E9%BB%91@2x.jpg',
  url_s: 'https://res.insta360.com/static/477d207fab87ca9e391e944e4f47d50b/02-%E9%BB%91.jpg',
};
const CREATOR_2 = {
  url: 'https://res.insta360.com/static/4a2528b65796b403e1155d99ae659d2b/03@2x.jpg',
  urlL: 'https://res.insta360.com/static/ef2df0e1aba9ec952e28e48bac6114aa/03@3x.jpg',
  url_m: 'https://res.insta360.com/static/4a2528b65796b403e1155d99ae659d2b/03@2x.jpg',
  url_s: 'https://res.insta360.com/static/a62deffd19b4c3ede35ef429bd11aa27/03.jpg',
};
const CREATOR_3 = {
  url: 'https://res.insta360.com/static/74f333d4fa3bd3dddd25ff97ec43950a/04@3x.jpg',
  urlL: 'https://res.insta360.com/static/74f333d4fa3bd3dddd25ff97ec43950a/04@3x.jpg',
  url_m: 'https://res.insta360.com/static/74f333d4fa3bd3dddd25ff97ec43950a/04@3x.jpg',
  url_s: 'https://res.insta360.com/static/0802919dfa2d94238234e80ee30c63f7/04.jpg',
};
const CREATOR_4 = {
  url: 'https://res.insta360.com/static/915f31801a332e887cb57ef42a34e6c8/05@2x.jpg',
  urlL: 'https://res.insta360.com/static/0ff151b1304d97152148b3e262717736/05@3x.jpg',
  url_m: 'https://res.insta360.com/static/915f31801a332e887cb57ef42a34e6c8/05@2x.jpg',
  url_s: 'https://res.insta360.com/static/984085467ad41588f1b81f49d5035114/05.jpg',
};
const WATER_WHITE_1 = {
  url: 'https://res.insta360.com/static/030dee49f1faddf0d0dab2d99a1bd2ea/01@2x.jpg',
  urlL: 'https://res.insta360.com/static/fa17d7139de762ab174e0f81bc4571ff/01@3x.jpg',
  url_m: 'https://res.insta360.com/static/030dee49f1faddf0d0dab2d99a1bd2ea/01@2x.jpg',
  url_s: 'https://res.insta360.com/static/d2a6fd1ee46d9d345a770381a6e204c4/01.jpg',
};
const WATER_BLACK_1 = {
  url: 'https://res.insta360.com/static/6071ece76737da4b5daceb93f6f0b899/02-%E9%BB%91@2x.jpg',
  urlL: 'https://res.insta360.com/static/e6de12733b5a9a3a28690580142313c4/02-%E9%BB%91@3x.jpg',
  url_m: 'https://res.insta360.com/static/6071ece76737da4b5daceb93f6f0b899/02-%E9%BB%91@2x.jpg',
  url_s: 'https://res.insta360.com/static/2e29c548a8ce1fb554e38e5bf127b862/02-%E9%BB%91.jpg',
};
const WATER_2 = {
  url: 'https://res.insta360.com/static/b99b1e75bdb0c775a7343fbbac86ca9f/03@2x.jpg',
  urlL: 'https://res.insta360.com/static/2201a1f057e5979b7a65912e753157f5/03@3x.jpg',
  url_m: 'https://res.insta360.com/static/b99b1e75bdb0c775a7343fbbac86ca9f/03@2x.jpg',
  url_s: 'https://res.insta360.com/static/3bc6dedeefe78aaecaf32e0ce6dd8924/03.jpg',
};
const WATER_3 = {
  url: 'https://res.insta360.com/static/d47207f3525d4d984937008777b6d2cb/04@2x.jpg',
  urlL: 'https://res.insta360.com/static/7b29c1744e9439a4167d376e0cd2c67a/04@3x.jpg',
  url_m: 'https://res.insta360.com/static/d47207f3525d4d984937008777b6d2cb/04@2x.jpg',
  url_s: 'https://res.insta360.com/static/3d7c9735af4bacf675f042adae67fb64/04.jpg',
};

const resourcesMapperFR = new Map([
  [3125, [STANDARD_WHITE_1, STANDARD_2, STANDARD_3, STANDARD_4]], // standard white
  [3135, [STANDARD_WHITE_1, STANDARD_2, STANDARD_3, STANDARD_4]], // standard white
  [3120, [STANDARD_BLACK_1, STANDARD_2, STANDARD_3, STANDARD_4]], // standard black
  [3130, [STANDARD_BLACK_1, STANDARD_2, STANDARD_3, STANDARD_4]], // standard black
  [3121, [FAMILY_BLACK_1, FAMILY_2, FAMILY_3, FAMILY_4]], // family black
  [3131, [FAMILY_BLACK_1, FAMILY_2, FAMILY_3, FAMILY_4]], // family black
  [3126, [FAMILY_WHITE_1, FAMILY_2, FAMILY_3, FAMILY_4]], // family white
  [3136, [FAMILY_WHITE_1, FAMILY_2, FAMILY_3, FAMILY_4]], // family white
  [3469, [ULTIMATE_BLACK_1, ULTIMATE_2, ULTIMATE_3, ULTIMATE_4]], // ultimate black
  [3470, [ULTIMATE_BLACK_1, ULTIMATE_2, ULTIMATE_3, ULTIMATE_4]], // ultimate black
  [3471, [ULTIMATE_WHITE_1, ULTIMATE_2, ULTIMATE_3, ULTIMATE_4]], // ultimate white
  [3472, [ULTIMATE_WHITE_1, ULTIMATE_2, ULTIMATE_3, ULTIMATE_4]], // ultimate white
  [3122, [ACTION_BLACK_1, ACTION_2, ACTION_3, ACTION_4]], // action black
  [3132, [ACTION_BLACK_1, ACTION_2, ACTION_3, ACTION_4]], // action black
  [3127, [ACTION_WHITE_1, ACTION_2, ACTION_3, ACTION_4]], // action white
  [3137, [ACTION_WHITE_1, ACTION_2, ACTION_3, ACTION_4]], // action white
  [3478, [CREATOR_BLACK_1, CREATOR_2, CREATOR_3, CREATOR_4]], // creator black
  [3479, [CREATOR_BLACK_1, CREATOR_2, CREATOR_3, CREATOR_4]], // creator black
  [3480, [CREATOR_WHITE_1, CREATOR_2, CREATOR_3, CREATOR_4]], // creator white
  [3481, [CREATOR_WHITE_1, CREATOR_2, CREATOR_3, CREATOR_4]], // creator white
  [3123, [WATER_BLACK_1, WATER_2, WATER_3]], // water black
  [3133, [WATER_BLACK_1, WATER_2, WATER_3]], // water black
  [3128, [WATER_WHITE_1, WATER_2, WATER_3]], // water white
  [3138, [WATER_WHITE_1, WATER_2, WATER_3]], // water white
]);

export default resourcesMapperFR;
